import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LazyLoadComponent from '../../core/components/LazyLoad/LazyLoadComponent';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    textAlign: 'center',
    borderRight: 'none',
    borderBottom: `1px solid ${theme.props.border.secondary.main}`,
    paddingBottom: 15,
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      borderRight: `1px solid ${theme.props.border.secondary.main}`,
      borderBottom: 'none',
      paddingBottom: 0,
    },
  },
  block: {
    display: 'inline-block',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  containerWrapper: {
    margin: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 1.5, 1.5),
    },
  },
  contentContainer: {
    justifyContent: 'center',
    alignItems: 'stretch',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'start',
    },
  },
  contentItem: {
    maxWidth: 140,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 0,
    },
  },
  contentName: {
    fontSize: theme.typography.pxToRem(12),
    marginTop: 'auto',
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const sizeMap = {
  largest: '70%',
  large: '80%',
};

const Content = ({ title, titleSecond, list }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3} md={2}>
        <Typography className={classes.title} color="primary">
          {title}
          <span className={classes.block}>{titleSecond}</span>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={9} md={10}>
        <div className={classes.containerWrapper}>
          <Grid container spacing={3} className={classes.contentContainer}>
            {list.map(({ imagePath, alt, name, size }, index) => (
              <Grid
                item
                xs={6}
                sm="auto"
                key={`performance-content${index}`}
                className={classes.contentItem}
              >
                <div
                  style={{
                    margin: 'auto',
                    ...(size in sizeMap && { maxWidth: sizeMap[size] }),
                  }}
                >
                  <LazyLoadComponent>
                    <img
                      src={imagePath}
                      alt={alt}
                      style={{ width: '100%', height: 'auto' }}
                    />
                  </LazyLoadComponent>
                </div>
                {!!name && (
                  <Typography className={classes.contentName}>
                    {name}
                  </Typography>
                )}
              </Grid>
            ))}
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

export default Content;
